/* ============================================================================
   Barnaby Bars — personaliser inspiration themes  (DRAFT — Barney to edit)

   One entry per gift theme. When an ad carries `theme: '<key>'`, the personaliser
   swaps EVERY "Need inspiration?" set (name · date · story) to that theme's ideas,
   across all three personalisation types.

   Shape per theme:
     name:  [ { name, anec, icon } ]        // the name "inspiration" tiles
     date:  [ { occasion, message, icon } ]  // the date "inspiration" tiles
     story: [ { title, chapters:[6], icon } ]// the story "inspiration" cards (6 chapters)

   icon ∈ heart · star · smile · people · rings · baby   (falls back to heart)
   Limits (match the inputs): name ≤ 10 chars · message/anecdote ≤ 40 chars ·
   chapter ≤ 26 chars.

   EDIT FREELY: wording, add/remove items, add new themes. Keep the keys stable —
   they're what the ad configs reference. `default` is used if a theme is missing.
   ========================================================================== */
(function () {
  window.bbPersonaliserThemes = {

    // ── Couple / romance ────────────────────────────────────────────────
    'anniversary': {
      label: 'Anniversary',
      name: [
        { name: 'My love',  anec: 'Still my favourite',   icon: 'heart' },
        { name: 'Us',       anec: 'Another year, still us', icon: 'rings' },
        { name: 'Darling',  anec: 'Here’s to us',      icon: 'heart' },
      ],
      date: [
        { occasion: 'The day we met',   message: 'The day we met',       icon: 'heart' },
        { occasion: 'Our first date',   message: 'Where it all began',   icon: 'star' },
        { occasion: 'The wedding',      message: 'I’d do it again',  icon: 'rings' },
      ],
      story: [
        { title: 'Our love story', icon: 'rings',
          chapters: ['We met', 'First date', 'Moved in', 'Engaged', 'Our wedding', 'Forever'] },
      ],
    },
    'relationship': {
      label: 'Relationship',
      name: [
        { name: 'You & me', anec: 'My person',           icon: 'heart' },
        { name: 'Babe',     anec: 'Lucky to have you',    icon: 'heart' },
        { name: 'Partner',  anec: 'My favourite person',  icon: 'rings' },
      ],
      date: [
        { occasion: 'The day we met', message: 'The day we met',     icon: 'heart' },
        { occasion: 'First kiss',     message: 'Still remember it',  icon: 'star' },
        { occasion: 'Our trip',       message: 'Just us two',        icon: 'smile' },
      ],
      story: [
        { title: 'How we began', icon: 'heart',
          chapters: ['We met', 'First date', 'First trip', 'Us against it', 'Moved in', 'Still here'] },
      ],
    },
    'moment-i-knew': {
      label: 'The Moment I Knew',
      name: [
        { name: 'You',       anec: 'The moment I knew',       icon: 'heart' },
        { name: 'My person', anec: 'When it all just clicked', icon: 'heart' },
        { name: 'Us',        anec: 'The day I finally knew',   icon: 'star' },
      ],
      date: [
        { occasion: 'Not when we met',    message: 'It wasn’t when we met',  icon: 'heart' },
        { occasion: 'Not our first date', message: 'Or our first date',      icon: 'star' },
        { occasion: 'It happened later',  message: 'It happened much later', icon: 'smile' },
      ],
      story: [
        { title: 'When I knew', icon: 'heart',
          chapters: ['Not when we met', 'Not our first date', 'Not the first kiss', 'It came later', 'You don’t remember', 'The last chip'] },
      ],
    },
    'engagement': {
      label: 'Engagement',
      name: [
        { name: 'Fiancé',  anec: 'Said yes!',          icon: 'rings' },
        { name: 'My one',    anec: 'Forever, official',    icon: 'heart' },
        { name: 'Bride2be',  anec: 'Counting down',        icon: 'rings' },
      ],
      date: [
        { occasion: 'The proposal',   message: 'You said yes',       icon: 'rings' },
        { occasion: 'The day we met', message: 'Where it started',   icon: 'heart' },
        { occasion: 'Our first date', message: 'The beginning',      icon: 'star' },
      ],
      story: [
        { title: 'To the proposal', icon: 'rings',
          chapters: ['We met', 'First date', 'Moved in', 'The plan', 'The question', 'She said yes'] },
      ],
    },
    'wedding': {
      label: 'Wedding',
      name: [
        { name: 'Mr & Mrs', anec: 'Just married',      icon: 'rings' },
        { name: 'The bride', anec: 'Radiant',           icon: 'heart' },
        { name: 'Newlyweds', anec: 'Day one of forever', icon: 'rings' },
      ],
      date: [
        { occasion: 'The wedding day', message: 'The best day',     icon: 'rings' },
        { occasion: 'The day we met',  message: 'Where it began',   icon: 'heart' },
        { occasion: 'The engagement',  message: 'You said yes',     icon: 'star' },
      ],
      story: [
        { title: 'To the aisle', icon: 'rings',
          chapters: ['We met', 'First date', 'Moved in', 'Engaged', 'The big day', 'Mr & Mrs'] },
      ],
    },
    'wedding-anniversary': {
      label: 'Wedding Anniversary',
      name: [
        { name: 'My wife',   anec: 'Still do',            icon: 'rings' },
        { name: 'My husband', anec: 'Years on, still us',  icon: 'rings' },
        { name: 'Us',        anec: 'Happily ever after',  icon: 'heart' },
      ],
      date: [
        { occasion: 'The wedding',    message: 'The best day',    icon: 'rings' },
        { occasion: 'The day we met', message: 'Where we began',  icon: 'heart' },
        { occasion: 'Our honeymoon',  message: 'Just us two',     icon: 'smile' },
      ],
      story: [
        { title: 'Our years', icon: 'rings',
          chapters: ['We wed', 'First home', 'Adventures', 'Ups & downs', 'Still laughing', 'Forever'] },
      ],
    },
    'long-distance': {
      label: 'Long Distance',
      name: [
        { name: 'You',       anec: 'Worth the miles',   icon: 'heart' },
        { name: 'Faraway',   anec: 'Close in my heart',  icon: 'star' },
        { name: 'My love',   anec: 'Soon, not far',      icon: 'heart' },
      ],
      date: [
        { occasion: 'The day we met',  message: 'Worth every mile', icon: 'heart' },
        { occasion: 'Last visit',      message: 'Until next time',  icon: 'smile' },
        { occasion: 'Next time we meet', message: 'Counting down',  icon: 'star' },
      ],
      story: [
        { title: 'The miles between', icon: 'heart',
          chapters: ['We met', 'The goodbye', 'Late calls', 'Every visit', 'Counting down', 'Together'] },
      ],
    },

    // ── Birthdays ───────────────────────────────────────────────────────
    'birthday': {
      label: 'Birthday',
      name: [
        { name: 'Birthday', anec: 'Another year of you', icon: 'star' },
        { name: 'You',      anec: 'Make a wish',          icon: 'smile' },
        { name: 'The star', anec: 'It’s your day',   icon: 'star' },
      ],
      date: [
        { occasion: 'The big day', message: 'Happy birthday',    icon: 'star' },
        { occasion: 'Born this day', message: 'The day you arrived', icon: 'baby' },
        { occasion: 'This year',   message: 'Best one yet',      icon: 'smile' },
      ],
      story: [
        { title: 'Your year', icon: 'star',
          chapters: ['The big day', 'Another year', 'Cake time', 'Make a wish', 'Celebrate', 'Cheers to you'] },
      ],
    },
    'milestone-birthday': {
      label: 'Milestone Birthday',
      name: [
        { name: 'The big 40', anec: 'Fabulous at 40',   icon: 'star' },
        { name: 'Half a ton', anec: '50 and thriving',  icon: 'smile' },
        { name: 'Legend',     anec: 'Still got it',      icon: 'star' },
      ],
      date: [
        { occasion: 'The milestone', message: 'A big one',         icon: 'star' },
        { occasion: 'The day you were born', message: 'Where it began', icon: 'baby' },
        { occasion: 'The party',     message: 'Let’s celebrate', icon: 'smile' },
      ],
      story: [
        { title: 'Decades of you', icon: 'star',
          chapters: ['Born', 'Growing up', 'Big moments', 'Your prime', 'This milestone', 'Here’s to more'] },
      ],
    },

    // ── Family ──────────────────────────────────────────────────────────
    'new-baby': {
      label: 'New Baby',
      name: [
        { name: 'Baby',     anec: 'Welcome, little one', icon: 'baby' },
        { name: 'Little one', anec: 'So loved already',  icon: 'heart' },
        { name: 'Our boy',  anec: 'Worth the wait',      icon: 'baby' },
      ],
      date: [
        { occasion: 'The due date',  message: 'Almost here',       icon: 'baby' },
        { occasion: 'You arrived',   message: 'Our whole world',   icon: 'heart' },
        { occasion: 'The big news',  message: 'We’re expecting', icon: 'star' },
      ],
      story: [
        { title: 'Hello, little one', icon: 'baby',
          chapters: ['The big news', 'Bump days', 'You arrived', 'First smile', 'First steps', 'First birthday'] },
      ],
    },
    'new-parent': {
      label: 'New Parent',
      name: [
        { name: 'New mum',  anec: 'You’ve got this', icon: 'heart' },
        { name: 'New dad',  anec: 'A natural',            icon: 'star' },
        { name: 'Parents',  anec: 'Team of three now',    icon: 'people' },
      ],
      date: [
        { occasion: 'The big news', message: 'We’re expecting', icon: 'star' },
        { occasion: 'Baby arrived', message: 'Life changed',       icon: 'baby' },
        { occasion: 'First night home', message: 'Just the three', icon: 'heart' },
      ],
      story: [
        { title: 'Becoming parents', icon: 'baby',
          chapters: ['The news', 'The bump', 'The arrival', 'Sleepless nights', 'First smile', 'Worth it all'] },
      ],
    },
    'mothers-day': {
      label: 'Mother’s Day',
      name: [
        { name: 'Mum',   anec: 'The best of us',     icon: 'heart' },
        { name: 'Mummy', anec: 'My whole heart',     icon: 'heart' },
        { name: 'Nana',  anec: 'Endless love',       icon: 'star' },
      ],
      date: [
        { occasion: 'The day I was born', message: 'You made me', icon: 'baby' },
        { occasion: 'A day with Mum',   message: 'Just us',       icon: 'heart' },
        { occasion: 'Her birthday',     message: 'For you, always', icon: 'star' },
      ],
      story: [
        { title: 'Thanks, Mum', icon: 'heart',
          chapters: ['You raised me', 'The lessons', 'The laughs', 'Always there', 'My rock', 'Thank you'] },
      ],
    },
    'fathers-day': {
      label: 'Father’s Day',
      name: [
        { name: 'Dad',     anec: 'King of the BBQ',  icon: 'star' },
        { name: 'Daddy',   anec: 'My hero',          icon: 'star' },
        { name: 'Grandad', anec: 'Full of stories',  icon: 'smile' },
      ],
      date: [
        { occasion: 'The day I was born', message: 'You taught me', icon: 'baby' },
        { occasion: 'A day with Dad',   message: 'The best days',  icon: 'smile' },
        { occasion: 'His birthday',     message: 'For you, Dad',   icon: 'star' },
      ],
      story: [
        { title: 'Thanks, Dad', icon: 'star',
          chapters: ['You showed me', 'The bike', 'The advice', 'Always there', 'My hero', 'Thank you'] },
      ],
    },
    'retirement': {
      label: 'Retirement',
      name: [
        { name: 'Boss',    anec: 'Enjoy every minute', icon: 'star' },
        { name: 'Legend',  anec: 'Earned this',        icon: 'smile' },
        { name: 'Retiree', anec: 'The next chapter',   icon: 'star' },
      ],
      date: [
        { occasion: 'First day',  message: 'Where it started', icon: 'star' },
        { occasion: 'Last day',   message: 'What a run',        icon: 'smile' },
        { occasion: 'Day one free', message: 'Enjoy it all',   icon: 'heart' },
      ],
      story: [
        { title: 'The career', icon: 'star',
          chapters: ['Day one', 'Climbing up', 'The big wins', 'The team', 'Last day', 'Freedom'] },
      ],
    },

    // ── Congratulations / milestones ────────────────────────────────────
    'graduation': {
      label: 'Graduation',
      name: [
        { name: 'Grad',    anec: 'You did it!',       icon: 'star' },
        { name: 'Scholar', anec: 'So proud of you',   icon: 'smile' },
        { name: 'Doctor',  anec: 'Made it, finally',  icon: 'star' },
      ],
      date: [
        { occasion: 'Graduation day', message: 'You did it', icon: 'star' },
        { occasion: 'First day',      message: 'Where it began', icon: 'smile' },
        { occasion: 'Results day',    message: 'All worth it', icon: 'heart' },
      ],
      story: [
        { title: 'The degree', icon: 'star',
          chapters: ['First day', 'Late nights', 'The exams', 'The friends', 'Graduation', 'What’s next'] },
      ],
    },
    'congratulations': {
      label: 'Congratulations',
      name: [
        { name: 'Superstar', anec: 'You smashed it', icon: 'star' },
        { name: 'Champ',     anec: 'So well earned', icon: 'smile' },
        { name: 'Winner',    anec: 'Knew you could', icon: 'star' },
      ],
      date: [
        { occasion: 'The big win',  message: 'You did it',      icon: 'star' },
        { occasion: 'The news',     message: 'So proud',        icon: 'heart' },
        { occasion: 'The first day', message: 'Onwards & up',   icon: 'smile' },
      ],
      story: [
        { title: 'You did it', icon: 'star',
          chapters: ['The goal', 'The graft', 'The setbacks', 'The push', 'The win', 'What’s next'] },
      ],
    },
    'new-home': {
      label: 'New Home',
      name: [
        { name: 'Home',     anec: 'Keys at last',     icon: 'heart' },
        { name: 'Nesters',  anec: 'Home sweet home',  icon: 'people' },
        { name: 'New pad',  anec: 'Cheers to this',   icon: 'star' },
      ],
      date: [
        { occasion: 'Completion day', message: 'The keys!',      icon: 'star' },
        { occasion: 'First night',    message: 'Home at last',   icon: 'heart' },
        { occasion: 'Offer accepted', message: 'It’s ours', icon: 'smile' },
      ],
      story: [
        { title: 'Our first home', icon: 'heart',
          chapters: ['The search', 'The offer', 'The keys', 'Moving in', 'Making it ours', 'Home'] },
      ],
    },
    'leaving': {
      label: 'Leaving',
      name: [
        { name: 'The team', anec: 'Won’t be the same', icon: 'people' },
        { name: 'Legend',   anec: 'Go get ’em',       icon: 'star' },
        { name: 'You',      anec: 'Onto big things',       icon: 'smile' },
      ],
      date: [
        { occasion: 'First day',  message: 'Where it started', icon: 'star' },
        { occasion: 'Last day',   message: 'What a ride',       icon: 'smile' },
        { occasion: 'The send-off', message: 'You’ll be missed', icon: 'heart' },
      ],
      story: [
        { title: 'Your time here', icon: 'people',
          chapters: ['Day one', 'The team', 'The laughs', 'The wins', 'Last day', 'Good luck'] },
      ],
    },
    'good-luck': {
      label: 'Good Luck',
      name: [
        { name: 'You',      anec: 'You’ve got this', icon: 'star' },
        { name: 'Champ',    anec: 'Go get ’em',     icon: 'smile' },
        { name: 'Trooper',  anec: 'Rooting for you',     icon: 'heart' },
      ],
      date: [
        { occasion: 'The big day', message: 'You’ve got this', icon: 'star' },
        { occasion: 'Day one',     message: 'New beginnings',       icon: 'smile' },
        { occasion: 'The interview', message: 'Go smash it',        icon: 'heart' },
      ],
      story: [
        { title: 'The next chapter', icon: 'star',
          chapters: ['The decision', 'The prep', 'The nerves', 'The leap', 'Day one', 'You’ve got this'] },
      ],
    },

    // ── Thinking of you / support ───────────────────────────────────────
    'thank-you': {
      label: 'Thank You',
      name: [
        { name: 'Thank you', anec: 'You’re the best', icon: 'heart' },
        { name: 'Legend',    anec: 'Couldn’t have',   icon: 'star' },
        { name: 'You',       anec: 'So grateful',          icon: 'smile' },
      ],
      date: [
        { occasion: 'The day you helped', message: 'I owe you one', icon: 'heart' },
        { occasion: 'Just because',       message: 'A big thank you', icon: 'star' },
        { occasion: 'Our time together',  message: 'Grateful for you', icon: 'smile' },
      ],
      story: [
        { title: 'Thank you', icon: 'heart',
          chapters: ['You showed up', 'You listened', 'You helped', 'You stayed', 'You mattered', 'Thank you'] },
      ],
    },
    'thinking-of-you': {
      label: 'Thinking Of You',
      name: [
        { name: 'You',      anec: 'Thinking of you',   icon: 'heart' },
        { name: 'Friend',   anec: 'Here for you',       icon: 'smile' },
        { name: 'Dear you', anec: 'Sending love',       icon: 'heart' },
      ],
      date: [
        { occasion: 'Just because', message: 'Thinking of you', icon: 'heart' },
        { occasion: 'A good memory', message: 'Remember this?',  icon: 'smile' },
        { occasion: 'Our day',      message: 'Miss you',        icon: 'star' },
      ],
      story: [
        { title: 'Thinking of you', icon: 'heart',
          chapters: ['A good day', 'A shared laugh', 'A quiet moment', 'A memory', 'Still here', 'Sending love'] },
      ],
    },
    'get-well-soon': {
      label: 'Get Well Soon',
      name: [
        { name: 'You',      anec: 'Rest up soon',      icon: 'heart' },
        { name: 'Trooper',  anec: 'Back on your feet',  icon: 'star' },
        { name: 'Dear you', anec: 'Sending strength',   icon: 'heart' },
      ],
      date: [
        { occasion: 'Get well soon', message: 'Rest up',        icon: 'heart' },
        { occasion: 'Better days',   message: 'Soon as ever',    icon: 'smile' },
        { occasion: 'Just because',  message: 'Thinking of you', icon: 'star' },
      ],
      story: [
        { title: 'Get well soon', icon: 'heart',
          chapters: ['Take it easy', 'One day at a time', 'Little wins', 'Rest up', 'Getting there', 'Back soon'] },
      ],
    },
    'sympathy': {
      label: 'Sympathy',
      name: [
        { name: 'With love', anec: 'Here for you',    icon: 'heart' },
        { name: 'Dear you',  anec: 'Thinking of you',  icon: 'heart' },
        { name: 'Always',    anec: 'In our hearts',    icon: 'star' },
      ],
      date: [
        { occasion: 'A cherished day', message: 'Always remembered', icon: 'heart' },
        { occasion: 'In memory',       message: 'Forever loved',     icon: 'star' },
        { occasion: 'Thinking of you', message: 'Here for you',      icon: 'heart' },
      ],
      story: [
        { title: 'In loving memory', icon: 'heart',
          chapters: ['A life well lived', 'The love', 'The laughter', 'The memories', 'Always with us', 'Never forgotten'] },
      ],
    },

    // ── Seasonal / everyday ─────────────────────────────────────────────
    'christmas': {
      label: 'Christmas',
      name: [
        { name: 'Merry you', anec: 'Ho ho ho',        icon: 'star' },
        { name: 'Family',    anec: 'Home for Xmas',    icon: 'people' },
        { name: 'You',       anec: 'Season’s best', icon: 'heart' },
      ],
      date: [
        { occasion: 'Christmas Day', message: 'Merry Christmas',   icon: 'star' },
        { occasion: 'First Christmas', message: 'One to remember', icon: 'baby' },
        { occasion: 'Our tradition', message: 'Every year',        icon: 'heart' },
      ],
      story: [
        { title: 'Our Christmas', icon: 'star',
          chapters: ['The tree', 'The wrapping', 'The eve', 'The morning', 'The feast', 'Together'] },
      ],
    },
    'friendship': {
      label: 'Friendship',
      name: [
        { name: 'Best mate', anec: 'Worst jokes',     icon: 'smile' },
        { name: 'Bestie',    anec: 'Partner in crime', icon: 'people' },
        { name: 'My people', anec: 'Ride or die',      icon: 'people' },
      ],
      date: [
        { occasion: 'The day we met', message: 'Instant mates',   icon: 'smile' },
        { occasion: 'Our big trip',   message: 'What a laugh',     icon: 'star' },
        { occasion: 'That night out', message: 'Never forget it',  icon: 'people' },
      ],
      story: [
        { title: 'Best friends', icon: 'people',
          chapters: ['We met', 'First adventure', 'Thick & thin', 'Big laughs', 'Always there', 'Best friends'] },
      ],
    },
    'just-because': {
      label: 'Just Because',
      name: [
        { name: 'You',      anec: 'Just because',      icon: 'heart' },
        { name: 'Legend',   anec: 'You’re the best', icon: 'star' },
        { name: 'Favourite', anec: 'Thought of you',   icon: 'smile' },
      ],
      date: [
        { occasion: 'Just because',  message: 'No reason needed', icon: 'heart' },
        { occasion: 'A good memory', message: 'Remember this?',    icon: 'smile' },
        { occasion: 'Today',         message: 'Thinking of you',   icon: 'star' },
      ],
      story: [
        { title: 'Just you', icon: 'heart',
          chapters: ['A good day', 'A shared laugh', 'A silly moment', 'A memory', 'Still smiling', 'For you'] },
      ],
    },

  };

  // Fallback used when an ad's theme key isn't found above.
  window.bbPersonaliserThemes['default'] = window.bbPersonaliserThemes['just-because'];
})();
